'use client';

import { useMemo } from "react";
import { I18nextProvider } from "react-i18next";
import { createI18n } from "../lib/i18n/createI18n";
import type { Locale } from "../lib/i18n/utils";

type I18nProviderProps = {
  children: React.ReactNode;
  locale: Locale;
};

export default function I18nProvider({ children, locale }: I18nProviderProps) {
  const i18n = useMemo(() => createI18n(locale), [locale]);
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

